import { render, staticRenderFns } from "./SalesExcelUpload.vue?vue&type=template&id=2954e4fa&"
import script from "./SalesExcelUpload.vue?vue&type=script&lang=js&"
export * from "./SalesExcelUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports